/**
 * OrbPostMachinesWithTraitsPart1VisionENOrbPostMachinesWithTraitsPart1VisionENPage
 *
 * Page component for OrbPostMachinesWithTraitsPart1VisionENOrbPostMachinesWithTraitsPart1VisionENPage
 * Path: /blog/machines-with-traits-part-1-vision
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbPostMachinesWithTraitsPart1VisionENPostPageView as __OrbPostMachinesWithTraitsPart1VisionENPostPageView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionENPostPageView';
import { OrbPostMachinesWithTraitsPart1VisionENPostAnalyticsView as __OrbPostMachinesWithTraitsPart1VisionENPostAnalyticsView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionENPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbPostMachinesWithTraitsPart1VisionENOrbPostMachinesWithTraitsPart1VisionENPageProps {
  // Add any page-level props here
}

export function OrbPostMachinesWithTraitsPart1VisionENOrbPostMachinesWithTraitsPart1VisionENPage(_props: OrbPostMachinesWithTraitsPart1VisionENOrbPostMachinesWithTraitsPart1VisionENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Machines with Traits: How Orb Will Change the Future of Robotics","description":"Imagine a world where you don't need to write thousands of lines of code to make a robot move intelligently. A world where you declare a machine's behavior the same way you describe the motion of planets in their orbits.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/blog/machines-with-traits-part-1-vision"},{"locale":"ar","path":"/ar/blog/machines-with-traits-part-1-vision"},{"locale":"sl","path":"/sl/blog/machines-with-traits-part-1-vision"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbPostMachinesWithTraitsPart1VisionENPostPageView config={{ initPayload: __navState }} />
          <__OrbPostMachinesWithTraitsPart1VisionENPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbPostMachinesWithTraitsPart1VisionENOrbPostMachinesWithTraitsPart1VisionENPage;
